import ApiService from '../services/ApiService';
import FileService from '../services/FileService';

export default class VideoRepository {
    constructor() {
        this.apiService = new ApiService();
        this.fileService = new FileService();
    }

    createVideo(data) {
        data = this.transformVideoDataForRequest(data);
        return new Promise((resolve, reject) => {
            this.apiService
                .post('videos', data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteVideo(id) {
        return new Promise((resolve, reject) => {
            this.apiService
                .delete('videos/' + id)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getVideos(sort) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('videos?sort=' + sort)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    transformVideoDataForRequest(data, method = null) {
        if (data.video) {
            data.video = this.fileService.convertBase64ToFIle(
                data.video,
                data.videoName
            );
        } else {
            delete data.video;
        }

        return this.apiService.convertDataToFormData(data, method);
    }

    updateVideo(id, data) {
        data = this.transformVideoDataForRequest(data, 'PUT');
        return new Promise((resolve, reject) => {
            this.apiService
                .post('videos/' + id, data)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}
